import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import { env } from 'app/utils/env';
import { history } from 'app/utils/history';

import { rootReducer } from './reducers';
import { sagas } from './sagas';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({ maxAge: 150 });

export const config = {
  env: env.env,
  appUrl: env.appUrl,
  apiUrl: env.apiUrl,
  amplitudeKey: env.amplitudeKey,
};

const initialState = {
  navigation: config,
};

export const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware))
);

sagaMiddleware.run(sagas);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
